/*global define, dna*/
define('core/services/CmsService',['angular'], function (angular) {
    'use strict';
    angular.module('dnaApp').factory('CmsService', ['$q', '$log', '$http', 'CacheFactory', '$sce', function ($q, $log, $http, CacheFactory, $sce) {
        CacheFactory('cmsSpotCache');
        var cmsShortCache = CacheFactory('cmsShortCache', {
            maxAge: 180000, // Keep items for three minutes.
            capacity: 16
        });

        /**
         * @class CmsService
         * @desc Service used for retrieving html content of cms spots.
         */
        return {
            /**
             * @method CmsService.getSpotByNameUsingCustomUrl
             * @desc Retrieve the CMS content for the specified spot name using a custom URL. This is to allow for additional
             * @param spotName
             * @param params
             * @param customUrl
             */
            getSpotByNameUsingCustomUrl: function (params, customUrl) {
                var deferred = $q.defer();

                if (cmsShortCache.get(customUrl)) {
                    deferred.resolve(cmsShortCache.get(customUrl));
                } else {
                    $http({
                        method: 'GET',
                        url: customUrl,
                        params: params,
                        headers: {
                            'Accept': 'text/html; charset=UTF-8'
                        }
                    }).success(function (data) {
                        var html = $sce.trustAsHtml(data);
                        CacheFactory.get('cmsSpotCache').put(customUrl, html);
                        deferred.resolve(html);
                    }).error(function (data) {
                        deferred.reject(data);
                    });
                }
                return deferred.promise;
            },

            /**
             * @method CmsService.getSpotByName
             * @desc Retrieve the CMS content for the specified spot name.
             * @param {String} spotName The name of the cms spot to retrieve.
             * @returns {Promise} The promise to be resolved or rejected.
             * @public
             */
            getSpotByName: function (spotName, params) {
                var deferred = $q.defer();

                var url = '/cmsSpotByName/' + spotName;
                if (CacheFactory.get('cmsSpotCache').get(url)) {
                    deferred.resolve(CacheFactory.get('cmsSpotCache').get(url));
                } else {
                    $http({
                        method: 'GET',
                        url: url,
                        params: params,
                        headers: {
                            'Accept': 'text/html; charset=UTF-8'
                        }
                    }).success(function (data, status, headers, config) {
                        var html = $sce.trustAsHtml(data);
                        CacheFactory.get('cmsSpotCache').put(url, html);
                        deferred.resolve(html, status, headers, config);
                    }).error(function (data, status, headers, config) {
                        deferred.reject(data, status, headers, config);
                    });
                }
                return deferred.promise;
            }
        };
    }]);
});

